import React from 'react';
import Button from '@components/ui/Button/Button';
import styles from '@components/ui/Modal/Modal.module.css';
import logoutIcon from '@assets/header/logout.svg';

interface BusinessOverviewModalProps {
  isClosing?: boolean;
  onClose: () => void;
  onSwitchBusiness: () => void;
  businessName: string;
}

const BusinessOverviewModal: React.FC<BusinessOverviewModalProps> = ({
  isClosing,
  onClose,
  onSwitchBusiness,
  businessName,
}) => {
  const handleSwitchClick = () => {
    onSwitchBusiness();
    onClose();
  };

  return (
    <div className={`${styles.businessModal} ${isClosing ? styles.closing : ''}`}>
      <div className={styles.modalTitle}>{businessName}</div>
      <div className={styles.modalSeparator}></div>
      <div className={styles.modalButtons}>
        <Button
          variant="text"
          size="md"
          fullWidth
          className={styles.menuItem}
          onClick={handleSwitchClick}
        >
          <img src={logoutIcon} alt="Switch business icon" className={styles.buttonIcon} />
          Switch Business Account
        </Button>
      </div>
    </div>
  );
};

export default BusinessOverviewModal;
